import CancellableHelper from "@/requests/CancellableHelper";
import { RELATED_EMAIL_TYPE } from "@/static/relatedEmailTypes";
import { NotificationData } from "@/models/api/mail/NotificationData";
import { EmailContentAndSubject } from "@/models/api/mail/EmailContentAndSubject";
import { MailContentAndSubjectRequest } from "@/models/api/mail/MailContentAndSubjectRequest";
import {
  DocumentMailNotification,
  DocumentMailNotificationResponse,
  SaveDocumentMailNotificationStatus,
} from "@/models/api/mail/DocumentMailNotification";
import { SendMail } from "@/models/api/mail/SendMail";
import { FileTmp } from "@/models/api/Files";
import { axiosInstance } from "@/plugins/axios";

//#region Routes
export const URL_GET_MAIL_NOTIFICATION_DATA = "/Mail/GetNotificationData/${RelatedEmailType}";
export const URL_GET_MAIL_CONTENT_AND_SUBJECT = "/Mail/GetMailContentAndSubject/${RelatedEmailType}";
export const URL_POST_SEND_MAIL = "/Mail/SendMail";
export const URL_GET_MAIL_NOTIFICATION_STATUSES = "/Mail/MailNotificationStatuses/${RelatedEmailType}";
export const URL_POST_UPLOAD_MAIL_ATTACHMENT_FILE = "/File/UploadMailAttachmentFile";
export const URL_POST_SAVE_MAIL_NOTIFICATION_STATUSES = "/Mail/SaveMailNotificationStatusData/${RelatedEmailType}";
//#endregion

const _getNotificationData = new CancellableHelper<NotificationData>(URL_GET_MAIL_NOTIFICATION_DATA, NotificationData);
export const getNotificationData = async (
  documentIds: Array<string>,
  relatedEmailType: RELATED_EMAIL_TYPE
): Promise<NotificationData> => {
  return await _getNotificationData.get({ DocumentIds: documentIds, RelatedEmailType: relatedEmailType });
};

const _getMailContentAndSubject = new CancellableHelper<EmailContentAndSubject>(
  URL_GET_MAIL_CONTENT_AND_SUBJECT,
  EmailContentAndSubject
);
export const getMailContentAndSubject = async (
  param: MailContentAndSubjectRequest
): Promise<EmailContentAndSubject> => {
  return await _getMailContentAndSubject.get(param);
};

const _sendMail = new CancellableHelper<null>(URL_POST_SEND_MAIL, null, true);
export const sendMail = async (param: SendMail): Promise<null> => {
  return await _sendMail.post({}, param);
};

export const getMailNotificationStatuses = async (
  documentIds: Array<string>,
  relatedEmailType: RELATED_EMAIL_TYPE
): Promise<DocumentMailNotificationResponse> => {
  const _getMailNotificationStatuses = new CancellableHelper<DocumentMailNotificationResponse>(
    URL_GET_MAIL_NOTIFICATION_STATUSES,
    DocumentMailNotification
  );
  return await _getMailNotificationStatuses.get({ DocumentIds: documentIds, RelatedEmailType: relatedEmailType });
};

const _saveMailNotificationStatuses = new CancellableHelper<null>(URL_POST_SAVE_MAIL_NOTIFICATION_STATUSES, null, true);

export const saveMailNotificationStatuses = async (
  documentMailNotificationStatus: Array<SaveDocumentMailNotificationStatus>,
  relatedEmailType: RELATED_EMAIL_TYPE
): Promise<null> => {
  return await _saveMailNotificationStatuses.post(
    { RelatedEmailType: relatedEmailType },
    documentMailNotificationStatus
  );
};

export const postUploadMailAttachmentFile = async (files: Array<File>): Promise<Array<FileTmp>> => {
  const formData = new FormData();
  for (const file of files) formData.append(file.name, file);
  const response = await axiosInstance.post(URL_POST_UPLOAD_MAIL_ATTACHMENT_FILE, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as Array<FileTmp>;
};
